import React from 'react';
import classNames from 'classnames';
import config from 'config/config';
import SocialButton from 'src/components/buttons/socialButton';
import { setLangCookie } from 'src/utils/cookie';
import i18n from 'i18next';
import ButtonDropdown from 'src/components/buttons//buttonDropdown/buttonDropdown';
import { DropdownItem } from 'reactstrap';

const year = new Date().getFullYear();

const LANGUAGES = {
  'en': 'English',
  'es': 'Español',
  'pt': 'Português',
};

class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isReduced: true,
      isCompanySectionHidden: true,
      isProductSectionHidden: true,
      isSupportSectionHidden: true,
    };
  }

  onLanguageSelected = (lang) => {
    setLangCookie(lang);
    this.props.updateLanguage(lang);
  }

  renderBlock = ({ title, isSectionHiddenKey, links }) => {
    const isSectionHidden = this.state[isSectionHiddenKey];
    const iconClassName = classNames({
      'icon': true,
      'visible-xs': true,
      'icon-down-1': isSectionHidden,
      'icon-up-1': !isSectionHidden,
    });
    const linksClassName = classNames({
      'hidden-xs': isSectionHidden,
    });

    return (
      <div className='footer-col-2 footer__block' key={`footer-section-${title}`}>
        <div className="footer__block-header">
          <h4>{title}</h4>
          <div>
            <span
              className={iconClassName}
              onClick={() => this.setState({ [isSectionHiddenKey]: !isSectionHidden })}
            />
          </div>
        </div>
        <div className={linksClassName}>
          {links.map(link => (
            <p key={`link-${link.text}`}>
              <a
                href={link.href}
                target="_blank"
              >
                {link.text}
              </a>
            </p>
          ))}
        </div>
      </div>
    );
  }

  renderAppStoreLogo() {
    return (
      <a href="https://itunes.apple.com/app/apple-store/id1016950959?pt=1924360&ct=footer&mt=8" target="_blank" >
        <img className="footer__appstore-image" src={`${config.cdn.static}img/home/app-store.png`} alt="App store" />
        <div className="footer__app-stars" >
          &#9733; &#9733; &#9733; &#9733; &#9733;  {i18n.t('Average rating')}: 4.8
        </div>
      </a>
    );
  }

  render() {
    const { isLoggedIn, lang } = this.props;
    const footerClasses = classNames({
      'footer': true,
      'hidden-xs': isLoggedIn && this.state.isReduced,
    });

    const footerBottomClasses = classNames({
      'footer__bottom': true,
      'hidden-xs': isLoggedIn && this.state.isReduced,
    });

    const reducedFooter = isLoggedIn && this.state.isReduced
      ? <div className="reduced-footer">
        <p>&copy; {year} HealthUnlocked</p>
        <div
          className="reduced-footer__show-more"
          onClick={() => this.setState({ isReduced: !this.state.isReduced })}>
          {i18n.t('Show footer')}
        </div>
      </div>
      : null;

    const sections = [
      {
        title: i18n.t('Company'),
        isSectionHiddenKey: 'isCompanySectionHidden',
        links: [
          { href: '/about', text: i18n.t('About Us') },
          { href: '/about/team', text: i18n.t('Our Team') },
          { href: '/about/business', text: i18n.t('Business') },
          { href: '/about/jobs', text: i18n.t('Jobs') },
          { href: '/about/news', text: i18n.t('News') },
          { href: 'http://blog.healthunlocked.com', text: i18n.t('Blog') },
        ],
      },
      {
        title: i18n.t('Product'),
        isSectionHiddenKey: 'isProductSectionHidden',
        links: [
          { href: '/conditions', text: i18n.t('A-Z conditions') },
          { href: '/treatments', text: i18n.t('A-Z treatments') },
          { href: '/find', text: i18n.t('A-Z communities') },
          { href: '/resources', text: i18n.t('Resources') },
          { href: 'https://itunes.apple.com/app/apple-store/id1016950959?pt=1924360&ct=footer&mt=8', text: i18n.t('iPhone app') },
          { href: '/start', text: i18n.t('Start a Community') },
        ],
      },
      {
        title: i18n.t('Support'),
        isSectionHiddenKey: 'isSupportSectionHidden',
        links: [
          { href: config.community[lang].support, text: i18n.t('Help Centre') },
          { href: config.guides.guideline[lang], text: i18n.t('Community Guidelines') },
          { href: 'https://support.healthunlocked.com/customer/portal/emails/new', text: i18n.t('Contact us') },
        ],
      },
    ];

    return (
      <div>
        {reducedFooter}
        <div className={footerClasses}>
          <div className='footer-columns'>
            <div className='footer-col-2'>
              <img alt="Logo" src={`${config.cdn.static}img/healthunlocked-logo-white.png`} className='logo'/>
              <div className='footer-copy'>&copy; {year} {i18n.t('All rights reserved.')}</div>
              <div className='footer__social'>
                <a href={config.community[lang].blog} target='_blank'>
                  <SocialButton brand="tumblr" />
                </a>
                <a href={config.community[lang].fb} target='_blank'>
                  <SocialButton brand="facebook" />
                </a>
                <a href={config.community[lang].twitter} target='_blank'>
                  <SocialButton brand="twitter" />
                </a>
                <a href='http://youtube.com/healthunlocked' target='_blank'>
                  <SocialButton brand="youtube" />
                </a>
                <a href='http://instagram.com/healthunlocked' target='_blank'>
                  <SocialButton brand="instagram" />
                </a>
              </div>
              <div className="footer__appstore-logo hidden-xs">
                {this.renderAppStoreLogo()}
              </div>
            </div>
            {sections.map(this.renderBlock)}
            <div className="footer__appstore-logo visible-xs">
              {this.renderAppStoreLogo()}
            </div>
            {
              isLoggedIn && !this.state.isReduced &&
              <div
                className="footer__hide visible-xs"
                onClick={() => this.setState({ isReduced: !this.state.isReduced })}>
                  {i18n.t('Hide footer')}
              </div>
            }
          </div>
        </div>
        <div className={footerBottomClasses}>
          <div className="footer__bottom-content">
            <div>
              <a href='/policies/terms' target='_blank'>{i18n.t('Terms')}</a>
              <a href='/policies/privacy' target='_blank'>{i18n.t('Privacy')}</a>
              <a href='/policies/security' target='_blank'>{i18n.t('Security')}</a>
              <a href='/policies/cookies' target='_blank'>{i18n.t('Cookies')}</a>
            </div>
            <div>
              <ButtonDropdown
                color="languages"
                text={`${i18n.t('Language')}: ${LANGUAGES[lang]}  `}
              >
                {Object.keys(LANGUAGES).map(language => (
                  <DropdownItem
                    key={`lang-filter-${language}`}
                    onClick={() => this.onLanguageSelected(language)}
                  >
                    {LANGUAGES[language]}
                  </DropdownItem>
                ))}
              </ButtonDropdown>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js